/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Fleet } from '../models/Fleet';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FleetInsightsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns Fleet Fleet
   * @throws ApiError
   */
  public getFleetInsights({
    policyId,
    dbName,
  }: {
    policyId: string,
    dbName?: string,
  }): CancelablePromise<Fleet> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}',
      path: {
        'policyId': policyId,
      },
      query: {
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

}
